import { createSignal, For, JSX, Show } from "solid-js";

export type FAQ = {
  question: string;
  answer: string;
};

export function Accordion(props: {
  faqs: FAQ[];
  title: string | null;
}): JSX.Element {
  return (
    <Show when={props.faqs.length > 0}>
      <div class="flex w-full flex-col gap-2">
        {/* Section Header */}
        <Show when={props.title}>
          <h2 class="text-title-4-semi-bold text-text-normal-primary">
            {props.title}
          </h2>
        </Show>

        {/* FAQ Accordion */}
        <div class="flex flex-col gap-3">
          <For each={props.faqs}>
            {(faq) => <FaqItem question={faq.question} answer={faq.answer} />}
          </For>
        </div>
      </div>
    </Show>
  );
}

function FaqItem(props: { question: string; answer: string }): JSX.Element {
  const [isExpanded, setIsExpanded] = createSignal(false);

  return (
    <button
      onClick={() => setIsExpanded(!isExpanded())}
      class="flex flex-col gap-1 rounded-2xl bg-background-normal-secondary p-4"
    >
      {/* Question - Clickable Header */}
      <div class="flex w-full items-center gap-2 text-left">
        <span class="flex-1 text-para-3-semi-bold text-text-normal-primary">
          {props.question}
        </span>
        <ToggleIcon isExpanded={isExpanded()} />
      </div>

      {/* Answer - Collapsible Content */}
      <Show when={isExpanded()}>
        <p class="text-start text-para-3-regular text-text-normal-primary">
          {props.answer}
        </p>
      </Show>
    </button>
  );
}

function ToggleIcon(props: { isExpanded: boolean }): JSX.Element {
  return (
    <svg
      class="size-5 shrink-0"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Show
        when={props.isExpanded}
        fallback={
          // Plus icon for closed state
          <path
            d="M10 4.16667V15.8333M4.16667 10H15.8333"
            stroke="currentColor"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="stroke-text-normal-secondary"
          />
        }
      >
        {/* Minus icon for expanded state */}
        <path
          d="M4.16667 10H15.8333"
          stroke="currentColor"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="stroke-text-normal-secondary"
        />
      </Show>
    </svg>
  );
}
